import { createSlice } from '@reduxjs/toolkit';
import { ReportsState } from '../../types';

import { REPORTS_STATE } from '../../constants';

import { setReportsLoadingStatus } from './setReportsLoadingStatus';
import { setReports } from './setReports';

import { setReportLoadingStatus } from './setReportLoadingStatus';
import { setReportDownloadStatus } from './setReportDownloadStatus';
import { setReportGuid } from './setReportGuid';
import { resetReportGuid } from './resetReportGuid';
import { setReport } from './setReport';

import { setUnauthorizedReport } from './setUnauthorizedReport';
import { setUnauthorizedReportStatus } from './setUnauthorizedReportStatus';
import { setUnauthorizedReportDownloadStatus } from './setUnauthorizedReportDownloadStatus';
import { resetUnauthorizedReport } from './resetUnauthorizedReport';
import { setUnauthReportStatusResponse } from './setUnauthReportStatusResponse';

const initialState: ReportsState = {
  reports: {},
  report: {},
  unauthorizedReport: {},
};

export const reportsSlice = createSlice({
  name: REPORTS_STATE,
  initialState,
  reducers: {
    setReportsLoadingStatus,
    setReports,

    setReportLoadingStatus,
    setReportDownloadStatus,
    setReportGuid,
    resetReportGuid,
    setReport,

    setUnauthorizedReport,
    setUnauthorizedReportStatus,
    setUnauthorizedReportDownloadStatus,
    setUnauthReportStatusResponse,
    resetUnauthorizedReport,
  },
});

export const reportsActions = reportsSlice.actions;
export const reportsReducer = reportsSlice.reducer;
